import React from 'react';

import UserCard from './UserCard'; 

const UserManagement = ({ users, expandedUser, setExpandedUser, assignProjectToUser, updateUserData }) => {
    return (
        <div className="users-container">
            {users.map((user) => (
                <UserCard
                    key={user.email}
                    user={user}
                    isExpanded={expandedUser === user.email}
                    onToggle={(email) => setExpandedUser(expandedUser === email ? null : email)}
                />
            ))}
        </div>
    );
};

export default UserManagement; 